// React
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
// MUI
import { Grid, Box, Button, TextField, FormControl } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import { InitialAreaState, AreaSchema } from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from 'formik';
import toast from 'react-hot-toast';
// Hooks
import usePermissions from "../../../hooks/usePermissions";

const Area = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [area, setArea] = useState(InitialAreaState);

    const getArea = async () => {
        spinService.on();
        const response = await get(EntityConstants.AREAS + `/${id}`);
        const data = await response.json();
        setArea(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        if (values.id === undefined) {
            const response = await post(EntityConstants.AREAS, { area: values });
            if ([200, 201].indexOf(response.status) > -1) {
                toast.success(MessageContants.AREA_CREATED);
                onClose();
            }
        } else {
            const response = await put(EntityConstants.AREAS + `/${values.id}`, { area: values });
            if ([200, 201].indexOf(response.status) > -1) {
                toast.success(MessageContants.AREA_UPDATED);
                onClose();
            }
        }
        spinService.off();
    };
    useEffect(() => {
        if (id !== undefined) {
            getArea();
        }
    }, [id])
    return (
        <Formik
            enableReinitialize
            initialValues={area}
            validationSchema={AreaSchema}
            onSubmit={values => handleSubmit(values)}
        >
            {({ values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit }) => (

                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid >
                            <FormControl fullWidth color="info">
                                <TextField
                                    variant="outlined"
                                    required
                                    id="name"
                                    label="Name"
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    error={errors.name && touched.name}
                                />
                            </FormControl>
                        </Grid>
                        <Box sx={{ p: 2, textAlign: 'right' }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.AREA_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.AREA_UPDATE))) &&
                                <Button variant="contained" startIcon={<Iconify icon="eva:save-fill" />} type="submit">
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    )
};

Area.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default Area;